<template>
    <div>
        <div class="d-flex align-items-center filter-wrapper flex-wrap">
            <div class="form-group">
                <label>Дата начала периода</label>
                <date-component v-model="currFilters.dateFrom"/>
            </div>
            <div class="form-group">
                <label>Дата окончания периода</label>
                <date-component v-model="currFilters.dateTo"/>
            </div>
            <div class="form-group select2">
                <label>Район</label>
                <Select2 :options="districts" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.districtIds"/>
            </div>
            <div class="form-group select2">
                <label>Тип ОУ</label>
                <Select2 :options="organizationTypes" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.organizationTypeIds"/>
            </div>
            <div class="form-group select2">
                <label>Наименование ОУ</label>
                <Select2 :options="organizations" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.organizationIds"/>
            </div>
            <div class="form-group select2">
                <label>Специалист &mdash; план</label>
                <Select2 :options="specialists" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.specialistPlanIds"/>
            </div>
            <div class="form-group select2">
                <label>Специалист &mdash; факт</label>
                <Select2 :options="specialists" :settings="{multiple:true,language:'ru'}" placeholder="(Все)"
                         v-model="currFilters.specialistFactIds"/>
            </div>



        </div>
      <div class="form-group px-0 col-4 select2">
        <div class="d-flex align-items-center">
          <label class="mr-2">Отобразить в отчете</label>
          <Checkbox v-model="fieldsChecked"
                    :checked="fieldsChecked"
                    id="fieldsSpec2"
                    text="Все поля"
          />
        </div>
        <span v-if="currFilters && currFilters?.fields.length < 1" class="text-danger">Выберите минимум одно поле</span>
        <Select2 :options="fields" :settings="{multiple:true,language:'ru'}" placeholder="(Выберите поля)"
                 v-model="currFilters.fields"/>
      </div>
      <div class="form-group px-0 col-2">
        <div class="card-footer px-0 d-flex">
          <button-component :disabled="currFilters && currFilters?.fields.length < 1" @click="apply" class="btn-xs">Сформировать</button-component>
          <button-component kind="secondary" class="btn-xs" @click="reset">Сбросить</button-component>
          <button class="btn-success btn-d btn-xs" @click="exportReport">
            <i class="fa fa-download"></i>Экспорт</button>
        </div>
      </div>
    </div>
</template>

<script>
  import DateComponent from "../../../common/components/DateComponent";
  import ButtonComponent from "../../../common/ui/ButtonComponent";
  import NsiApi from "../../admin/api/nsi";
  import OrgApi from "../../organization/api/organizations";
  import Api from "../api/serviceproviders";
  import Constants from "../../../common/constants";
  import Checkbox from "../../../common/ui/checkbox";
  export default {
    name: "ReportSpecialistsFilter",
    components: {ButtonComponent, DateComponent, Checkbox},
    props: {
      filters: Object
    },
    data() {
      return {
        fieldsChecked: true,
        districts: [],
        organizationTypes: [],
        organizations: [],
        specialists: [],
        fields: [],
        currFilters: this.filters,
        correctionFields: ['SpecialistPlan', 'SpecialistFact', "DistrictName", "OrganizationTypeName", "OrganizationName" ]
      }
    },
    created() {
      this.loadDictionaries();

    },
    watch: {
      fieldsChecked: {
        handler(val) {
          if(val === true) {
            this.currFilters.fields = this.fields.map(item => item.id)
          }
          if(val === false) {
            this.currFilters.fields = []
          }
        },
        deep: true
      },

    },

    methods: {
      loadDictionaries() {
        NsiApi.getNsi('district')
          .then((response) => {
            this.districts = response.data;
          });
        NsiApi.getNsi('specialist')
          .then((response) => {
            this.specialists = response.data;
          });
        NsiApi.getOrganizationTypes(Constants.KindActivityEducation)
          .then((response) => {
            this.organizationTypes = response.data;
          });
        OrgApi.search({pageNumber: 0, pageSize: -1, kindActivityId: Constants.KindActivityEducation})
          .then((response) => {
            this.organizations = response.data.items.map(x => ({id: x.id, text: x.name}));
          });
        Api.getSpecialistsReportFields()
          .then((response) => {
            this.fields = response.data.map((x) => ({id: x.name, text: x.title}));
            this.currFilters.fields = this.fields.map(item => item.id)
          });
      },
      apply() {
          const filters = Object.assign({}, this.currFilters);
          this.$emit('apply', filters);

      },
      reset() {
        this.currFilters = {
          dateFrom: null,
          dateTo: null,
          districtIds: [],
          organizationTypeIds: [],
          organizationIds: [],
          specialistPlanIds: [],
          specialistFactIds: [],
          fields: []
        };
        const filters = Object.assign({}, this.currFilters);
        this.$emit('reset', filters);
      },
      exportReport() {
        const filters = Object.assign({}, this.currFilters);
        this.$emit('exportReport', filters);
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import "src/assets/theme/default/colors";

    .form-group {
        label {
            font-weight: 400 !important;
            color: $gray-dark;
            font-size: 16px;
        }
    }
    .filter-wrapper{
        div:not(:last-child){
            margin-right: 16px;
        }
    }
    .card-footer {
        padding-top: 36px;
        gap: 16px;
        align-items: center;
        justify-content: space-between;
    }
    .btn-d{
      min-width: 120px;
        border: none;
        padding: 14px 24px;
        border-radius: 24px;
        i{
            padding-right: 12px;
        }
    }
</style>